import { Outlet } from 'react-router-dom'
import Profile from 'context/Profile'
import Guard from 'components/Guard'
import Theme from 'components/Theme'

const App = () => {

  return <Profile>
    <Guard>
      <Theme>
        <Outlet />
      </Theme>
    </Guard>
  </Profile>
}

export default App
